/* IncompleteModal — modal exibido quando o pesquisador tenta
 * enviar para Revisão Humana com pendências obrigatórias.
 */
import { AlertOctagon, ArrowLeft, Save } from "lucide-react";

export default function IncompleteModal({ open, pendencies = [], onClose, onSaveDraft, savingDraft }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="incomplete-title"
      data-testid="incomplete-modal"
    >
      <div className="card-mil max-w-md w-full p-5 space-y-4">
        <div className="flex items-start gap-3">
          <div className="rounded-full bg-rose-100 dark:bg-rose-950/40 p-2.5 shrink-0">
            <AlertOctagon size={20} className="text-rose-600" />
          </div>
          <div className="min-w-0">
            <h3 id="incomplete-title" className="font-display font-bold text-lg">
              Cadastro incompleto
            </h3>
            <p className="text-sm text-[var(--text-muted)] mt-1">
              Há {pendencies.length} pendência(s) obrigatória(s) impedindo o envio para Revisão Humana:
            </p>
          </div>
        </div>

        <ul
          className="space-y-1.5 text-sm pl-2 max-h-64 overflow-y-auto"
          data-testid="incomplete-pendencies-list"
        >
          {pendencies.map((p) => (
            <li
              key={p}
              className="text-rose-700 dark:text-rose-300 flex items-start gap-2"
            >
              <span className="text-rose-500 mt-0.5">•</span>
              <span>{p}</span>
            </li>
          ))}
        </ul>

        <div className="flex flex-col sm:flex-row gap-2 pt-2 border-t border-[var(--border)]">
          <button
            type="button"
            onClick={onClose}
            className="btn-gold flex-1 flex items-center justify-center gap-2"
            data-testid="incomplete-back-button"
          >
            <ArrowLeft size={14} /> Voltar e corrigir
          </button>
          <button
            type="button"
            onClick={onSaveDraft}
            disabled={savingDraft}
            className="btn-ghost flex-1 flex items-center justify-center gap-2"
            data-testid="incomplete-save-draft-button"
          >
            <Save size={14} /> {savingDraft ? "Salvando…" : "Salvar como rascunho"}
          </button>
        </div>
      </div>
    </div>
  );
}
